<mat-card appearance="outlined" class="disk-usage-card">
  <div class="header row">
    <h2>Site Disk Usage</h2>
    <fa-icon
      [icon]="['fas', 'circle-info']"
      size="lg"
      matTooltip="Database storage is calculated separately and is not included in the client's total disk usage."
    ></fa-icon>
    <!-- <span>Total: <b>2 GB</b> / 200 GB</span> -->
  </div>

  <!-- <div class="info row">
    <div class="usage">
      <div class="texts">
        <span>Files</span>
        <span>1 GB / 200 GB</span>
      </div>
      <mat-progress-bar mode="determinate" value="40"></mat-progress-bar>
    </div>

    <div class="usage">
      <div class="texts">
        <span>Databases</span>
        <span>500 MB / 200 GB</span>
      </div>
      <mat-progress-bar mode="determinate" value="30"></mat-progress-bar>
      <i class="hint">Databases do not count in total disk usage</i>
    </div>

    <div class="usage">
      <div class="texts">
        <span>Mailboxes</span>
        <span>500 MB / 200 GB</span>
      </div>
      <mat-progress-bar mode="determinate" value="20"></mat-progress-bar>
    </div>
  </div> -->

  <div class="small-cards">
    <div class="elevated card">
      <div class="row">
        <fa-icon [icon]="['fas', 'folder-open']" size="lg"></fa-icon>
        <span>Files</span>
      </div>
      <span class="bold">{{ filesUsage() | bytesToSize }}</span>
    </div>

    <div class="elevated card">
      <div class="row">
        <fa-icon [icon]="['fas', 'envelope']" size="lg"></fa-icon>
        <span>Mailboxes</span>
      </div>
      <span class="bold">{{ mailboxesUsage() | bytesToSize }}</span>
    </div>

    <div class="elevated card">
      <div class="row">
        <fa-icon [icon]="['fas', 'database']" size="lg"></fa-icon>
        <span>Databases</span>
      </div>
      <span class="bold">{{ databasesUsage() | bytesToSize }}</span>
    </div>
  </div>

  <div class="usages">
    <div class="column">
      <div class="usage row">
        <div class="label row">
          <fa-icon [icon]="['fas', 'database']" size="lg"></fa-icon>
          <span>Site Total (db incl.)</span>
        </div>

        <mat-progress-bar mode="determinate" [value]="siteTotalPercentage()"></mat-progress-bar>
        <span>
          <span class="bold">{{ siteTotal() | bytesToSize }}</span>
          / {{ diskUsage()?.quotaSnapshot?.blockHard | bytesToSize }}</span
        >
      </div>
      <div class="hint row">
        <span
          >Last updated: <b>{{ lastUpdated() }}</b>
        </span>
        @let downtime = syncDowntime();
        <button
          matRipple
          class="icon-button"
          [matTooltip]="`The disk space data can be refreshed every ${downtime ? downtime / 60 : '30'} minutes`"
          [disabled]="isDisabled()"
          (click)="syncDiskUsage()"
        >
          <fa-icon [icon]="['fas', 'arrows-rotate']" size="lg" class="btn-icon"></fa-icon>
        </button>
      </div>
    </div>
    <div class="column">
      <div class="usage row">
        <div class="label row">
          <fa-icon [icon]="['fas', 'house']" size="lg"></fa-icon>
          <span>Plan usage (db excl.)</span>
        </div>

        <mat-progress-bar mode="determinate" [value]="homeDirPercentage()"></mat-progress-bar>
        <span>
          <span class="bold">{{ diskUsage()?.quotaSnapshot?.blockUsed | bytesToSize }} </span>
          / {{ diskUsage()?.quotaSnapshot?.blockHard | bytesToSize }}</span
        >
      </div>
      <div class="hint">
        <span>Updates automatically every {{ updateInterval() }} minutes.</span>
      </div>
    </div>
  </div>
</mat-card>
